import { useActions, useQueryParams, useState } from 'src/hooks'
import { VerifyPhoneNumberSuccessFragment } from 'src/graphql/generated/graphql'
import { useUpdateAccount } from 'src/react_query'
import Result from 'src/utils/Result'
import { PhoneNumberVerificationDialogForAccount } from 'src/phone_number_verification/PhoneNumberVerificationDialogForAccount'

type ActSendFreeCardDialogProps = {
  onClose: () => void
  onFinished: () => void
}

export const ActSendFreeCardDialog = (props: ActSendFreeCardDialogProps) => {
  const { onClose, onFinished } = props

  const actions = useActions()
  const { sponsor } = useQueryParams()

  const [firstName, setFirstName] = useState<string | undefined>()
  const [lastName, setLastName] = useState<string | undefined>()

  const updateAccount = useUpdateAccount()

  const setUpAccount = async (
    success: VerifyPhoneNumberSuccessFragment,
    firstName?: string,
    lastName?: string,
    sponsorGenealogyId?: string,
  ) => {
    try {
      actions.loadedUser(Result(success.verifiedAccount))
      const { updateAccount: updatedAccount } = await updateAccount.mutateAsync(
        {
          account: {
            firstName,
            lastName,
            sponsorGenealogyId,
          },
        },
      )
      actions.loginDone(Result(updatedAccount.account))
    } catch (error) {
      console.log(error ?? 'Failed to update account.')
    } finally {
      onFinished()
    }
  }

  const onSuccess = (success: VerifyPhoneNumberSuccessFragment) => {
    if (success.verifiedAccount.username) {
      actions.loginDone(Result(success.verifiedAccount))
      onFinished()
    } else if (
      !success.verifiedAccount.isQualifiedForFirstFreeCard &&
      !success.verifiedAccount.username
    ) {
      actions.clearRouteArgs()
      actions.loginDone(Result(success.verifiedAccount))
      actions.openAccount()
    } else {
      setUpAccount(success, firstName, lastName, sponsor)
    }
  }

  return (
    <PhoneNumberVerificationDialogForAccount
      dialog={{
        isOpen: true,
        onClose: onClose,
      }}
      sponsorGenealogyIdOrSlug={sponsor}
      isCreateOrLogin={true}
      shouldNotCreateNewAccount={false}
      onChangeFirstAndLastName={(firstname, lastname) => {
        setFirstName(firstname)
        setLastName(lastname)
      }}
      onSuccess={onSuccess}
    />
  )
}
